import { Paper, styled } from "@mui/material";

// Toolbox panel — flat, sits beside the canvas in the same plane.
// Just a hairline border on the right; no shadow, no card-elevation feel.
//
// Width follows the user-resizable parent container (RuleBuilder's left
// pane via LeftPanelResizer / useLeftPanelWidth). The panel itself just
// fills the slot so the toolbox content (search, variable sections, add
// buttons) stretches with the user's chosen width.
export const ToolboxPanel = styled(Paper)(() => ({
	flex: 1,
	minWidth: 0,
	width: "100%",
	height: "100%",
	background: "#FFFFFF",
	borderRadius: 0,
	overflow: "hidden",
	display: "flex",
	flexDirection: "column",
	borderRight: "1px solid rgba(13, 31, 48, 0.06)",
	boxShadow: "none",
}));